// extracted by mini-css-extract-plugin
export default {"questionText":"Question_questionText__AyY3v","wrapper":"Question_wrapper__UCGB8","answerList":"Question_answerList__tfQeL"};